export const SET_MAX_STEP = 'SET_MAX_STEP';
export const SET_STEP = 'SET_STEP';
export const RESET_STEP = 'RESET_STEP';
export const VALIDATE_STEP = 'VALIDATE_STEP';

export const nextStep = () => (dispatch, getState) => {
	const {currentStep, maxStep} = getState().steps
	if(maxStep > currentStep+1) {
		dispatch(_setStep(currentStep+1))
	}
}

export const setStep = (step) => (dispatch, getState) => {
	dispatch(_setStep(step))
}

export const setMaxStep = (maxStep) => (dispatch, getState) => {
	if(maxStep > 0) {
		dispatch(_setMaxStep(maxStep))
	}
}

export const validateStep = (step, valid) => (dispatch, getState) => {
	dispatch(_validateStep(step, valid))
}

const _validateStep = (step, valid) => ({
	type: VALIDATE_STEP,
	payload: {
		step, 
		valid,
	},
})

const _setStep = currentStep => ({
	type: SET_STEP,
	payload: {
		currentStep
	},
})

const _setMaxStep = maxStep => ({
	type: SET_MAX_STEP,
	payload: {
		maxStep
	},
})
